import { ActivitiesTypes } from './HealthRiskAssessment.types';

export const parseComplexKeyValueString = (message: string) => {
	const result: Record<string, string[]> = {};
	const pairs = message.split(';');

	for (const pair of pairs) {
		const [key, value] = pair.split(':').map((str) => str.trim());
		result[key] = value.split(',').map((item) => item.trim());
	}

	return result;
};

export const reverseDate = (date?: string) => {
	if (!date) {
		return '';
	}

	return date.split('-').reverse().join('/');
};

export const formatDate = (activity: ActivitiesTypes) => {
	if (activity.settings?.dateEnd) {
		return `${reverseDate(activity?.settings?.dateStart)} - ${reverseDate(
			activity?.settings?.dateEnd,
		)}`;
	}

	return reverseDate(activity?.settings?.dateStart);
};

export const getMinimumDate = (dateStart?: string) => {
	if (dateStart) {
		return new Date(dateStart);
	}

	return undefined;
};
